import React from 'react';

import { Group, Stack, Text } from '@mantine/core';
import { readableTextColor } from 'utils/colors';

import useProgramAgendaStyles from '../../../../styles';

interface EventCellProps {
  color: string;
  programName: string;
  totalPrograms: number | null | undefined;
  hasAssignment: boolean;
  onClick: () => void;
}

const EventCell = ({
  color,
  programName,
  totalPrograms,
  hasAssignment,
  onClick,
}: EventCellProps): JSX.Element => {
  const { classes } = useProgramAgendaStyles();
  const textColor = readableTextColor(color);

  return (
    <Group
      bg={color}
      className={classes.firstColumn}
      noWrap
      py='4px'
      onClick={onClick}
      sx={{ cursor: hasAssignment ? 'pointer' : 'default' }}
    >
      <Stack spacing={0}>
        <Text weight={600} size='md' color={textColor} lineClamp={1}>
          {programName}
        </Text>
        <Text size='sm' color={textColor} opacity={0.95} lineClamp={1}>
          {(totalPrograms ?? 1) === 1 ? '1 class' : `${totalPrograms ?? 1} classes`}
        </Text>
      </Stack>
    </Group>
  );
};

export default EventCell;
